import { TCocktail, TDdpCta, TRecommendationCocktail } from "@/shared/types";
import { DdpCta } from "../DdpCta";
import { SingleImg } from "../SingleImg";
import { getCocktailByIds, interaction } from "@/shared/utils";
import { useState, useEffect } from "react";
import { tracking } from "@/shared/tracking";
import { useAppStore, useCmsStore } from "@/components/AppHooks";
import { useRouter } from "next/navigation";
import { GetFpSiteName } from "@/shared/appInit";

export function TanquerayCocktailList(props: {
    cocktailList: Array<TRecommendationCocktail>,
} & {
    cta: Array<TDdpCta> | string,
    matchText: string,
}) {
    const { cocktailList, cta, matchText } = props;
    const [finalCocktailList, setFinalCocktailList] = useState<Array<TCocktail>>([])
    useEffect(() => {
        if (!cocktailList) return
        getCocktailByIds(cocktailList.map((item) => item.cocktailId)).then((cocktails) => {
            setFinalCocktailList(cocktails)
        })
    }, [cocktailList])
    const _cta = Array.isArray(cta) ? cta[0] : cta
    const { locale, storeConfig: {
        cocktailDetailOn,
        id: SiteId
    } } = useCmsStore()!
    const { results } = useAppStore()
    const router = useRouter()
    function cocktailClickHandler(cocktailInfo: TCocktail) {
        tracking({
            "event": "custom_event",
            "event_name": "recipe_tile",
            "recipe_name": cocktailInfo.cocktailTitle,
            "brand": {
                "key": null,
                "ref": null,
                "props": {
                    "children": null
                },
                "_owner": null
            },
            "recipe_id": cocktailInfo.id,
            "click_text": cta,
            "destination_page_path": `${locale}${cocktailDetailOn ? '/cocktaildetail?cocktailId=' + cocktailInfo.id : ''}`
        })
        interaction([cocktailInfo.id], GetFpSiteName(SiteId), results?.consumerId || '', 'Click')
    }
    return (
        <div className="tanqueray-cocktail-list">
            {
                cocktailList.map((item) => {
                    const cocktailInfo = finalCocktailList.find((cocktail) => cocktail.id === item.cocktailId)
                    if (!cocktailInfo) return null
                    return <div className="cocktail-item" key={item.cocktailId}>
                        <div className="cocktail-media-wrapper cursor-pointer" onClick={() => {
                            if (cocktailDetailOn) {
                                cocktailClickHandler(cocktailInfo)
                                const queryParams = new URLSearchParams(location.search)
                                queryParams.set('cocktailId', item.cocktailId)
                                router.push(`/${locale}/cocktaildetail${queryParams.toString() ? `?${queryParams.toString()}` : ''}`)
                            }

                        }}>
                            <SingleImg className="cocktail-img" image={cocktailInfo?.recipeFirstImage} />
                        </div>
                        <div className="cocktail-content-wrapper">
                            <span className="cocktail-compatible">{Math.round(item?.compatibility)}% {matchText}</span>
                            <h2 className="cocktail-title">{cocktailInfo?.cocktailTitle}</h2>
                            <div className="cocktail-desc" dangerouslySetInnerHTML={{ __html: cocktailInfo?.cocktailDescription }} />
                            {
                                cta && typeof cta === 'string' && <DdpCta className="cta-discover link" cta={{
                                    show: true,
                                    text: cta,
                                    url: cocktailDetailOn ? '/cocktaildetail?cocktailId=' + item.cocktailId : '#'
                                }} onClick={() => {
                                    if (cocktailDetailOn) {
                                        cocktailClickHandler(cocktailInfo)
                                    }
                                }} ></DdpCta>
                            }
                            {
                                _cta && typeof _cta === 'object' && <DdpCta className="cta-discover link" cta={{
                                    ..._cta,
                                    url: cocktailDetailOn ? `${_cta.url}?cocktailId=${item.cocktailId}` : '#'
                                }} onClick={() => {
                                    if (cocktailDetailOn) {
                                       cocktailClickHandler(cocktailInfo)
                                    }
                                }} ></DdpCta>
                            }

                        </div>

                    </div>
                })
            }
        </div>
    );
}